module.exports = __webpack_public_path__ + "static/img/close.d75a68e4.png";